export const MANIFESTO_ENUM = {
  TODOS: {
    id: 0,
    ordem: 1,
    nomeManifesto: 'Todos'
  },
  SUGESTAO: {
    id: 7,
    ordem: 2,
    codigo: 'SG'
  },
  ELOGIO: {
    id: 4,
    ordem: 3,
    codigo: 'EL'
  },
  INFORMACAO: {
    id: 6,
    ordem: 4,
    codigo: 'IN'
  },
  CRITICA: {
    id: 3,
    ordem: 5,
    codigo: 'CR'
  },
  LGPD: {
    id: 10,
    ordem: 6,
    codigo: 'LD'
  },
  CONSULTA: {
    id: 8,
    ordem: 7,
    codigo: 'SN'
  },
  RECLAMACAO: {
    id: 1,
    ordem: 8,
    codigo: 'RC'
  },
  DENUNCIA: {
    id: 2,
    ordem: 9,
    codigo: 'DN'
  },
  SOLICITACAO: {
    id: 5,
    ordem: 10,
    codigo: 'SO'
  },
  CPE: {
    id: 11,
    ordem: 11,
    codigo: 'CP'
  },
  FALE_COM_RH: {
    id: 12,
    ordem: 12,
    codigo: 'FR'
  },
  LAI: {
    id: 13,
    ordem: 13,
    codigo: 'LA'
  }
};
